import 'whatwg-fetch'
import 'init/noty.theme'
import { createConsumer } from '@rails/actioncable'
import Rails from '@rails/ujs'

/* eslint-disable-next-line import/no-unresolved */
import('stylesheets/application')

window.Cable = createConsumer()
Rails.start()
// require("@rails/activestorage").start()

require('init/timezone-cookie')()
require('init/plugins')
require('init/backbone')
require('init/bootstrap')
